function getQueryStringParameters() {
  var parameters = {}, hash;
  var q = document.URL.split('?')[1];
  if (q != undefined) {
    q = q.split('&');
    for (var i = 0; i < q.length; i++) {
      hash = q[i].split('=');
      parameters[hash[0]] = hash[1];
    }
  }
  return parameters;
}

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key))
      return false;
  }
  return true;
}

/// Takes a list of query parmeters and a FormData,
/// and appends the parameters to the form
function populateCartAttributes(parameters, formData) {
  if (isEmpty(parameters) == false) {
    const entries = Object.entries(parameters);
    let data = entries.map(([key, val] = entry) => {
      // apend these to the cart attributes
      // janky, solve at root!
      val = val.replace(/%2F/gi, "/");
      formData.append('attributes[' + key + ']', val)
    });
  }
  return formData
}

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName;

  for (let i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

function getUTMParams() {
  const utmParams = new URLSearchParams();
  const utmSource = sessionStorage.getItem("utm_source");
  const utmMedium = sessionStorage.getItem("utm_medium");
  const utmCampaign = sessionStorage.getItem("utm_campaign");

  if (utmSource) {
    utmParams.set("utm_source", utmSource)
  }
  if (utmMedium) {
    utmParams.set("utm_medium", utmMedium)
  }
  if (utmCampaign) {
    utmParams.set("utm_campaign", utmCampaign)
  }

  return utmParams;
}

/// Remove attributes from the cart
async function clearCartAndCheckout(config, bypassCartPage) {
  const promise1 = $.ajax({
    type: "GET",
    url: '/cart.js',
    dataType: 'json',
    success: function (resp) {
      var nullHash = {};
      for ([key, value] of Object.entries(resp.attributes)) {
        nullHash[key] = null;
      }
      $.ajax({
        type: "POST",
        url: '/cart/update.js',
        data: { attributes: nullHash },
        dataType: 'json'
      });
    }
  });

  const promise2 = fetch('/cart/clear.json', {
    method: "POST",
    headers: {
      "Accept": "application/json"
    }
  });

  Promise.all([promise1, promise2]).then((_) => {
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else {

          const utmParams = getUTMParams();
          let cartUrl = bypassCartPage ? "/checkout" : "/cart";
          if (utmParams.size > 0) {
            cartUrl += `?${utmParams.toString()}`;
          }

          const cartButton = document.querySelector('.header__icon--cart');
          if (!bypassCartPage && cartButton) {
            cartButton.click();
            return;
          }

          // default localization does not need to be in URL
          if (Shopify.locale != 'en') {
            window.location.href = locale_root + "/" + cartUrl
            return
          }

          window.location.href = cartUrl;

          return;
        }
      })
      .catch((e) => {
        console.error(e);
      })
  });
}

// Last minute func to try to remove all items from cart before adding new items
async function emptyCart() {
  const promise1 = $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    data: '',
    dataType: 'json',
    success: function () {
      // console.log('cart cleared');
    },
    error: function () {
      console.log('error clearing cart');
    },
  });

  await promise1;
}

// Adds a product to the users basket
function addItemToBasket(variantID, quantityToAdd, bypassCartPage) {
  if (parseInt(quantityToAdd, 10) != NaN) {
    quantityToAdd = parseInt(quantityToAdd, 10);
  }
  else {
    quantityToAdd = 1;
  }

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  let formData = new FormData();
  formData.append('quantity', quantityToAdd);
  formData.append('form_type', 'product');
  formData.append('id', variantID);

  // get any query string parameters, are we topping up an existing iccid?
  let parameters = {};
  // parameters.depart = document.getElementById('bundle-search-depart').value;
  // parameters.return = document.getElementById('bundle-search-return').value;   

  if (sessionStorage.getItem('topUpIccid')) {
    parameters.iccid = sessionStorage.getItem('topUpIccid');
    sessionStorage.removeItem('topUpIccid');
  }

  if (Shopify.locale !== null) {
    parameters.userLanguage = Shopify.locale;
  } else {
    parameters.userLanguage = 'en';
  }


  let checkoutUserAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (checkoutUserAgent) {
    parameters.userAgent = checkoutUserAgent;
  }

  if (deviceInfo) {
    parameters.deviceInfo = JSON.stringify(deviceInfo);
  }

  let tripDurationVal = sessionStorage.getItem('tripDuration')
  if (tripDurationVal > 0) {
    if (tripDurationVal == 1) {
      parameters.tripDuration = `${tripDurationVal} day`;
    }
    else {
      parameters.tripDuration = `${tripDurationVal} days`;
    }
  }

  // populate attributes from utils fn
  formData = populateCartAttributes(parameters, formData);

  config.body = formData;

  clearCartAndCheckout(config, bypassCartPage);
}

function localisationSearch(listId, inputId){
  let countryList = document.getElementById(listId);
  
  if (countryList) {
    document.getElementById(inputId).addEventListener('input', function() {
        let filter = this.value.toLowerCase();
        Array.from(countryList.children).forEach(item => {
          if(item.textContent.toLocaleLowerCase().includes(filter)){
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        })
    });
  }
}

